module.exports = __webpack_public_path__ + "img/3.2d307a92.jpg";